






import Vue from "vue";
import UpdatePasswordForm from "@/components/User/UpdatePasswordForm.vue";
import { UserService } from "../../services";
import { UpdatePasswordI } from "vue/types/vue";
import { AxiosResponse } from "axios";
export default Vue.extend({
  name: "UpdateUserPassword",
  components: {
    UpdatePasswordForm
  },
  data() {
    return {
      success: false,
      loading: false,
      unable: false,
      refresh: 0,
      updateMessage: ""
    };
  },
  methods: {
    updatePassword: async function (pw: UpdatePasswordI): Promise<void> {
      let update = {} as AxiosResponse;
      let updateMessage = "";
      try {
        this.loading = true;
        this.success = false;
        update = await UserService.updatePassword(pw);
        if (update.status === 200) {
          updateMessage = `Lösenord uppdaterat`;
        } else if (update.status === 403) {
          updateMessage = `Uppdatering av lösenord misslyckades: Felaktigt lösenord.`;
        } else if (update.status === 400) {
          updateMessage = `Uppdatering av lösenord misslyckades: ${update.data}`;
        } else {
          throw `Okänt fel`;
        }

        await new Promise<void>(resolve =>
          setTimeout(() => {
            resolve();
          }, 500)
        );
      } catch (error: any) {
        updateMessage = `Uppdatering av lösenord misslyckades: ${error.data.message}`;
      } finally {
        console.log("finally")
        this.success = update.status === 200;
        this.loading = false;
        this.updateMessage = updateMessage;
      }
    },
    confirm: function (): void {
      this.updateMessage = "";
      if (this.success) {
        this.refresh = Math.random();
      }
    }
  }
});
